<template>
  <div class="cmp-check-all">
    <!-- <span class="m-des mr-20">共234345条数据</span> -->

    <el-checkbox
      :indeterminate="isIndeterminate"
      v-model="checkAll"
      @change="handleCheckAllChange"
    >全部</el-checkbox>

    <el-checkbox-group
      class="check-groups"
      :class="{'fix-h': isFixHeight}"
      v-model="checkedIds"
      @change="handleCheckedChange"
    >
      <el-checkbox v-for="item in checkData" :label="item.dictCode" :key="item.dictCode">{{item.dictName}}</el-checkbox>
    </el-checkbox-group>

    <p class="show-all" :class="{'fix-h': isFixHeight}" @click="toggle" v-if="checkData.length>7">{{isFixHeight ? '展开全部' : '收起'}} <i></i></p>
  </div>
</template>

<script>
export default {
  watch: {
    checkedIds() {
      this.$emit('eventChecked', this.checkedIds)
    },
    checkData: {
      handler() {
        console.log(445, this.checkData)
        if(this.checkData.length > 7) {
          this.isFixHeight = true
        }
      },
      immediate: true
    }
  },
  props: {
    checkData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      checkAll: false,
      isIndeterminate: false,
      checkedIds: [],
      isFixHeight: false
    }
  },
  methods: {
    toggle() {
      this.isFixHeight = !this.isFixHeight
    },
    // 清空val
    cleanVal() {
      this.checkAll = false
      this.checkedIds = []
      this.isIndeterminate = false
    },
    handleCheckAllChange(val) {
      let idsArr = []
      this.checkData.forEach(item => {
        idsArr.push(item.dictCode)
      })
      this.checkedIds = val ? idsArr : []
      this.isIndeterminate = false
    },
    handleCheckedChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.checkData.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.checkData.length
    }
  }
}
</script>

<style lang="scss" scoped>
.cmp-check-all {
  padding: 30px 0;
  padding-left: 40px;
  .check-groups {
    &.fix-h {
      height: 350px;
      overflow: hidden;
    }
  }
  .show-all {
    margin-top: 20px;
    padding-left: 30px;
    color: #5D4339;
    font-size: 16px;
    line-height: 32px;
    display: flex;
    align-items: center;
    cursor: pointer;
    i {
      margin-left: 5px;
      width: 13px;
      height: 7px;
      background: url(~@images/icon_open_normal@2x.png) no-repeat center center;
      background-size: 100% 100%;
      transform: rotate(180deg);
    }
    &.fix-h {
      i {
        transform: rotate(0);
      }
    }
  }

  .el-checkbox {
    margin-right: 20px;
  }

  .el-checkbox-group {
    display: flex;
    flex-direction: column;
  }
  /deep/ .el-checkbox__inner {
    margin-top: 4px;
    width: 20px;
    height: 20px;
    // font-size: 24px;
    border-color: $primary;
    background-color: transparent;
    transition: none;
    &::after {
      border-color: $primary;
      width: 5px;
      height: 13px;
      top: 0px;
      left: 6px;
      border-width: 2px;
      
    }
  }
  // /deep/ .el-checkbox__input.is-checked .el-checkbox__inner::after {
  //   width: 100%;
  //   height: 100%;
  //   left: 0;
  //   top: 0;
  //   background: $primary;
  //   transform: rotate(0);
  // }
  /deep/ .el-checkbox {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    font-weight: normal;
    .el-checkbox__label {
      color: rgba($color: $primary, $alpha: 1);
      font-size: 20px;
      line-height: 24px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
      height: 4px;
      top: 7px;
      background-color: $primary;
    }
  }
}
</style>


